import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { ClientDashboardResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const clientDashboardKeys = {
  all: () => ['clientDashboard'] as const,
  detail: (props: { url: string }) =>
    [...clientDashboardKeys.all(), 'detail', props.url] as const,
};

export const clientDashboardQueries = {
  detail: (props: { url: string }) =>
    queryOptions({
      queryKey: clientDashboardKeys.detail(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientDashboardResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    }),
};
